// extracted by mini-css-extract-plugin
module.exports = {"heading":"Upwork_heading__3k5wn","contact__btn":"Upwork_contact__btn__2AF2J","upwork":"Upwork_upwork__4Mc-Z"};